import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "../components/question.css";
import RespondentFlowApi from "../services/respondentFlow.api";
import { updateStatus } from "../services/respondent.api";
import BounceLoader from "react-spinners/ClipLoader";
import * as StatusConstants from "../constants/status.constants";
import { TextField } from "@mui/material";
import LoggerService from "../services/logger.service";
import CommonFormLayout from "../components/CommonFormLayout";
import TextInputComponent from "../components/TextFieldInput";
import CheckboxInputComponent from "../components/CheckboxInput";
import RadioInputComponent from "../components/RadioInput";
import LoaderComponent from "../components/LoaderComponent";
import FormWrapper from "../components/question-components/form-wrapper";
import TextFieldQuestion from "../components/question-components/text-field";
import SingleSelectQuestion from "../components/question-components/single-select";
import MultiSelectQuestion from "../components/question-components/multi-select";
import FormSkeleton from "../components/question-components/form-skeleton";
import ButtonV2 from "../components/question-components/button";

const ProfilerQuesion = () => {
  const [data, setData] = useState([]);
  const [userId, setUserId] = useState(0);
  const [traceId, setTraceId] = useState("");
  const [token, setToken] = useState("");
  const [tokenId, setTokenId] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  let navigate = useNavigate();
  const [idx, setIdx] = useState(0);
  const [allData, setAllData] = useState([]);
  const [match, setMatch] = useState(true);
  const [errorIndex, setErrorIndex] = useState([]);

  useEffect(() => {
    getQuestions();
    // eslint-disable-next-line
  }, []);

  let getQuestions = async () => {
    try {
      let params = sessionStorage.getItem("params");
      let paramObj = JSON.parse(params);
      if (paramObj === null) {
        navigate("/error");
        return;
      }
      setToken(paramObj.token);
      setTokenId(paramObj.tokenId);
      LoggerService.log(paramObj.token, paramObj.vendorToken ?? "", "Getting profiler questions");

      let response = await RespondentFlowApi.post("/v1/profiling", params);

      if (response.questionList.length === 0) {
        LoggerService.log(paramObj.token, paramObj.vendorToken ?? "", "No profiling question received");
        await updateStatus(
          response.token,
          paramObj.tokenId,
          StatusConstants.STATUS_PROFILER_START,
          StatusConstants.SUB_STATUS_PROFILER_TO_SCREENER
        );
        LoggerService.log(
          paramObj.token,
          paramObj.vendorToken ?? "",
          "Redirecting to Router",
          `/st?token=${response.token}`
        );
        navigate(`/st?token=${response.token}`);
        return;
      }

      //TODO:: Remove this code
      let questionList = response.questionList.map((question) => {
        if (question.type === 1 || question.type === 2) {
          question.answerId = [];
        } else {
          question.answerText = null;
        }
        return question;
      });
      LoggerService.log(
        paramObj.token,
        paramObj.vendorToken ?? "",
        "Profiling questions received",
        JSON.stringify(questionList)
      );
      setUserId(response.userId);
      setTraceId(response.traceId);

      setAllData(questionList);
      LoggerService.log(
        paramObj.token,
        paramObj.vendorToken ?? "",
        "Displaying the 1st question " + questionList[0].text,
        JSON.stringify(questionList[0])
      );
    } catch (e) {
      console.log("Error", e);
      navigate("/error");
    }
  };

  let saveRsponse = (event) => {
    event.preventDefault();
    setMatch(false);
    if (errorIndex.length <= 0) {
      setIsSubmitting(true);
      let params = sessionStorage.getItem("params");
      let paramObj = JSON.parse(params);
      let question = data.length > 0 ? data[0].text : "";
      let reqObj = {};
      reqObj.userId = userId;
      reqObj.responses = data; //TODO:: Remove this code, do checking
      reqObj.traceId = traceId;
      reqObj.token = token;
      reqObj.tokenId = tokenId;
      LoggerService.log(
        token,
        paramObj.vendorToken ?? "",
        "Saving the " + idx + " question - " + question,
        JSON.stringify(reqObj)
      );
      RespondentFlowApi.post(`/v1/profiling/response?token=${token}`, reqObj)
        .then(async (response) => {
          LoggerService.log(
            token,
            paramObj.vendorToken ?? "",
            "User response saved on server",
            JSON.stringify(response)
          );
          if (idx + 1 <= allData.length - 1) {
            LoggerService.log(token, paramObj.vendorToken ?? "", "Displaying next question " + allData[idx + 1].text);
            setErrorIndex([]);
            setMatch(true);
            setIdx(idx + 1);
          } else {
            setErrorIndex([]);
            setMatch(true);
            LoggerService.log(token, paramObj.vendorToken ?? "", "Redirecting to Router", `/st?token=${token}`);
            await updateStatus(
              token,
              tokenId,
              StatusConstants.STATUS_PROFILER_START,
              StatusConstants.SUB_STATUS_PROFILER_TO_SCREENER
            );
            navigate(`/st?token=${token}`);
          }
          setErrorIndex([]);
          setMatch(true);
        })
        .catch(async (e) => {
          LoggerService.log(token, paramObj.vendorToken ?? "", "Error in saving profiler response ", JSON.stringify(e));
          navigate(`/error`);
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    }
  };

  useEffect(() => {
    let payload = [...allData];
    let slicePayload = payload.slice(idx, idx + 1);
    setData(slicePayload);
  }, [allData, idx]);

  useEffect(() => {
    let indexError = [];
    data.map((value, i) => {
      if (
        value?.answerId?.length === 0 ||
        value?.answerText === null ||
        value?.answerText === "" ||
        (value.id === 59 && value?.answerText > 99) ||
        (value.id === 59 && value?.answerText < 18)
      ) {
        if (!indexError.includes(i)) {
          indexError.push(i);
        }
      }
      return true;
    });
    setErrorIndex(indexError);
  }, [data]);

  const debounce = (e) => {
    e.preventDefault();
  };

  return (
    <div>
      {data.length <= 0 ? (
        <FormSkeleton />
      ) : (
        // <form
        // onSubmit={isSubmitting ? debounce : saveRsponse}
        // noValidate
        // className="max-w-3xl mx-auto w-full h-[100dvh] py-2 p-2 relative"
        // >
        //   {data.map((value, i) => (
        //     <CommonFormLayout
        //       key={value.id || i}
        //       header={<h2 className="text-base font-semibold">{value.text}</h2>}
        // description={
        //   !match && errorIndex.includes(i) ? (
        //     <span className="text-red-500 text-xs">
        //       This field is required!
        //     </span>
        //   ) : null
        // }
        //       shadow={true}
        //       padding={true}
        //       borderRadius={true}
        //       border={true}
        //       divider={true}
        //       footer={
        //         <div className="flex justify-end">
        // <button
        //   type="submit"
        //   className="button"
        //   disabled={isSubmitting}
        //   onClick={() => setMatch(false)}
        // >
        //   Next
        // </button>
        //         </div>
        //       }
        //     >
        //       <div className="flex flex-col gap-4">
        //         {/* Example: if question type 1 (radio), 4/3 (text), else checkboxes */}
        //         {value.type === 1 ? (
        //           <div
        //             className={
        //               value.options.length > 12
        //                 ? "grid md:grid-cols-2 gap-4 grid-cols-1 mt-2"
        //                 : "grid md:grid-cols-1 gap-4 grid-cols-1 mt-2"
        //             }
        //           >
        //             {value.options.map((item) => (
        //               <div
        //                 className="flex space-x-3 justify-start"
        //                 key={item.id}
        //               >
        //                 <RadioInputComponent
        //                   id={`radio_${item.id}`}
        //                   name={value.id}
        //                   label={item.text}
        //                   value={item?.id}
        //                   checked={value.answerId.includes(item?.id)}
        //                   onChange={(e, value) => {
        //                     let payload = [...data];
        //                     payload[i].answerId = [item?.id];

        //                     setData(payload);
        //                   }}
        //                 />
        //               </div>
        //             ))}
        //           </div>
        //         ) : value.type === 4 || value.type === 3 ? (
        //           <TextInputComponent
        //             id={`text_${value.id}`}
        //             value={value.answerText === null ? "" : value.answerText}
        //             type={
        //               value.type === 4 || value.type === 3 ? "number" : "text"
        //             }
        //             onChange={(e) => {
        // let payload = [...data];
        // payload[i].answerText = e.target.value;
        // setData(payload);
        //             }}
        //             error={!match && errorIndex.includes(i)}
        //             variant="outlined"
        // helperText={
        //   !match && errorIndex.includes(i)
        //     ? value.answerText > 99 && value.id === 59
        //       ? "This value cannot be greater than 100."
        //       : value.answerText < 18 && value.id === 59
        //       ? "This value cannot be less than 18."
        //       : "This field is required!"
        //     : ""
        // }
        //           />
        //         ) : (
        //           <div
        //             className={
        //               value.options.length > 12
        //                 ? "grid md:grid-cols-2 gap-4 grid-cols-1 mt-2"
        //                 : "grid md:grid-cols-1 gap-4 grid-cols-1 mt-2"
        //             }
        //           >
        //             {value.options.map((item) => (
        //               <div
        //                 className="flex space-x-3 items-center"
        //                 key={item.id}
        //               >
        //                 <CheckboxInputComponent
        //                   id={`checkbox_${item.id}`}
        //                   label={item.text}
        //                   checked={value.answerId.includes(item.id)}
        //                   onChange={(e, value) => {
        //                     let payload = [...data];
        //                     if (!e.target.checked) {
        //                       payload[i].answerId = payload[i].answerId.filter(
        //                         (answer) => answer !== item.id
        //                       );
        //                     } else {
        //                       payload[i].answerId.push(item.id);
        //                     }
        //                     setData(payload);
        //                   }}
        //                 />
        //               </div>
        //             ))}
        //           </div>
        //         )}
        //       </div>
        //     </CommonFormLayout>
        //   ))}
        // </form>
        <form
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              const form = e.currentTarget;
              form.requestSubmit();
            }
          }}
          onSubmit={saveRsponse}
          noValidate
          className="w-full h-[100dvh]"
        >
          <FormWrapper
            footer={
              <ButtonV2 type="submit" disabled={isSubmitting} onClick={() => setMatch(false)}>
                Next
              </ButtonV2>
            }
          >
            {data.map((value, i) => {
              const hasError = !match && errorIndex.includes(i);
              console.log("value", hasError);
              return (
                <React.Fragment key={value.id}>
                  {value.type === 1 ? (
                    <SingleSelectQuestion
                      question={{
                        id: value.id,
                        label: value.text,
                        options: value.options,
                        description: hasError ? "This field is required!" : null,
                        required: false,
                      }}
                      value={value?.answerId?.[0] || undefined}
                      onChange={(selected) => {
                        const payload = [...data];
                        payload[i].answerId = [selected];
                        setData(payload);
                      }}
                    />
                  ) : value.type === 4 || value.type === 3 ? (
                    <TextFieldQuestion
                      question={{
                        id: value.id,
                        label: value.text,
                        required: false,
                        description: hasError ? "This field is required!" : null,
                        type: value.type,
                      }}
                      value={value.answerText === null ? "" : value.answerText}
                      onChange={(e) => {
                        let payload = [...data];
                        payload[i].answerText = e;
                        setData(payload);
                      }}
                      error={hasError}
                      helperText={
                        hasError
                          ? value.id === 59
                            ? Number(value.answerText) > 99
                              ? "This value cannot be greater than 100."
                              : Number(value.answerText) < 18
                              ? "This value cannot be less than 18."
                              : "This field is required!"
                            : "This field is required!"
                          : ""
                      }
                    />
                  ) : value.type === 2 ? (
                    <MultiSelectQuestion
                      question={{
                        id: value.id,
                        label: value.text,
                        options: value.options,
                        required: false,
                        description: hasError ? "This field is required!" : null,
                      }}
                      value={value?.answerId || []}
                      onChange={(selectedValues) => {
                        const payload = [...data];
                        payload[i].answerId = selectedValues;
                        setData(payload);
                      }}
                    />
                  ) : null}
                </React.Fragment>
              );
            })}
          </FormWrapper>
        </form>
      )}
    </div>
  );
};

export default ProfilerQuesion;
